import newphoto from "../../../src/assets/Tech Team/New photo .png"
export const directorData=[
    {
    imgUrl: "/images/nhwm/PHOTO.png",
    name: "Dr. Monideep Boruah",
    designation: "MD, NHWM",
    description:
      "Dr. Monideep Boruah is an Applied & Clinical Nutritionist and Reviewer Scientist of  European Journal of Nutrition since 2014. He is a Public Speaker, Global Wellness Specialist and Healthcare Coach. Dr. Monideep Boruah has been helping many people to get prevented & reversing to normal condition from Deadly Lifestyle Diseases across the Globe by altering their food habits and lifestyle habits.",
    social: [
      {
        icon: "fa6-brands:facebook-f",
        href: "https://www.facebook.com/drmonideep.boruah",
      },
      {
        icon: "fa6-brands:linkedin-in",
        href: "https://www.linkedin.com/in/dr-monideep-boruah-608104163/",
      },
    ],
  },
]